import HtmlElement from './HtmlElement';
import { ResizeObserver } from '../ResizeObserver';

/**
 * Selector
 *
 * @var { Object }
 */
const Selector = {
	TABS: '.tabs',
	TAB: '.tabs-tab',
	TAB_CONTENT: '.tabs-content'
};

class Tab {
	constructor ($tab, tabs) {
		this.$tab = $tab;
		this.tabs = tabs;
		this.id = $tab.data('id');
		this.$content = this.tabs.$element.find(`${Selector.TAB_CONTENT}[data-id="${this.id}"]`);
		this.init();
	}

	init() {
		this.$tab.on('click', () => {
			this.tabs.setActiveTab(this.id);
		});
	}
}

const Tabs = (() => {
	/**
	 * Tabs
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class Tabs extends HtmlElement {
		onReady() {
			this.tabs = [];
			this.activeId = this.$element.data('active');
			this.$activeContent = null;
			this.resizeObserver = null;

			this.$element.find(Selector.TAB).each((i, tab) => {
				this.tabs.push(new Tab($(tab), this));
			});

			this.setActiveTab(this.activeId);
		}
		findTab(id) {
			return this.tabs.find((t) => t.id === id);
		}
		deactivateAllTabs() {
			for (const tab of this.tabs) {
				if (this.resizeObserver && tab.$content.get(0)) {
					this.resizeObserver.unobserve(tab.$content.get(0));
				}

				tab.$tab.removeClass('active');
				tab.$content.stop(true, false).animate({
					opacity: 0
				}, 300, () => {
					tab.$content.css('display', 'none');
				});
			}
		}

		setActiveTab(id) {
			this.$element.data('active', id);
			this.deactivateAllTabs();
			const tab = this.findTab(id);

			this.resizeObserver = new ResizeObserver((entries) => {
				for (const entry of entries) {
					this.$element.find('.tabs-contents').css('height', entry.target.clientHeight || 0);
				}
			});

			if (tab.$content.get(0)) {
				this.resizeObserver.observe(tab.$content.get(0));
			}

			tab.$tab.addClass('active');
			tab.$content.css('display', 'block');

			// If content contains slider(s)
			const $sliders = tab.$content.find('.swiper-container');
			if ($sliders.length) {
				$sliders.each((i, el) => {
					if (el.swiper) {
						el.swiper.update();
					}
				});
			}

			tab.$content.stop(true, false).animate({
				opacity: 1
			}, 300);
		}
	}
	return Tabs._getElements(Selector.TABS, Tabs);
})();

export default Tabs;
